import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { db } from '../firebase/config';

interface SponsorData {
  id: string;
  name: string;
  logoUrl: string;
  websiteUrl: string;
  order: number;
}

const SponsorsSection: React.FC = () => {
  const { t } = useTranslation();
  const [sponsors, setSponsors] = useState<SponsorData[]>([]);

  useEffect(() => {
    const unsub = db.collection('cms_bk_sponsors')
      .orderBy('order', 'asc')
      .onSnapshot(
        snap => setSponsors(snap.docs.map(doc => ({ id: doc.id, ...doc.data() } as SponsorData))),
        () => {}
      );
    return unsub;
  }, []);

  return (
    <section className="section bg-white">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-dark mb-4">{t('sponsors.title')}</h2>
          <p className="text-gray-700 max-w-3xl mx-auto">
            {t('sponsors.description')}
          </p>
        </div>

        {sponsors.length > 0 && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
            {sponsors.map(sp => (
              <a
                key={sp.id}
                href={sp.websiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                title={sp.name}
                className="flex items-center justify-center p-4 bg-gray-50 rounded-lg hover:shadow-md transition-shadow"
              >
                <img src={sp.logoUrl} alt={sp.name} className="max-h-20 object-contain" />
              </a>
            ))}
          </div>
        )}

        <div className="text-center">
          <p className="text-gray-700 mb-6">
            {t('sponsors.sponsorInfo')}
          </p>
          <Link to="/support-us" className="btn btn-primary">
            {t('sponsors.becomeASponsor')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SponsorsSection;

